/* eslint-disable jsx-a11y/anchor-is-valid */
import './Footer.scss';
import { Footer } from '@lmig/lmds-react-footer';
import { Disclaimer } from '@lmig/lmds-react-typography';
import { useEffect, useState } from 'react';
import { GetFooterContent } from './PageFooterAPI';
import { LogoLibertyMutualMedallion, LogoLibertyMutualVert } from '@lmig/lmds-react-logos';
import RichText from 'Feature/PageContent/Shared/Tiles/RichText';
import { IconCPRA } from '@lmig/lmds-react-icons';
import { isPublic } from 'Foundation/Configurations/GlobalConfiguration';
import UnauthenticatedPageFooter from './UnauthenticatedPageFooter';
import SocialMedia from './SocialMedia';
import FooterLinks from './FooterLinks';

interface IOldFooterContent {
  OneBrandLinks: string;
  OneBrandContent: string;
}
interface INewFooterContent {
  Links: string;
  FlexibleContent: string;
}

export default function PageFooter() {
  const [footerContent, setFooterContent] = useState<INewFooterContent | undefined>(undefined);

  useEffect(() => {
    const getFooterContentAsync = async () => {
      let data: IOldFooterContent | INewFooterContent | undefined = await GetFooterContent();
      if (data && 'OneBrandContent' in data && (data.OneBrandContent || data.OneBrandLinks)) {
        setFooterContent({ Links: data.OneBrandLinks, FlexibleContent: data.OneBrandContent });
      } else if (data && 'FlexibleContent' in data && (data.FlexibleContent || data.Links)) {
        setFooterContent(data); //sort panels by sortorder
      }
    };
    getFooterContentAsync();
  }, []);

  const window: IWindow = global.window;
  function CRPAClick() {
    if (window?.utag?.gdpr) {
      window.utag.gdpr.showDoNotSellPrompt();
    }
  }

  return (
    <>
      {isPublic() ? <UnauthenticatedPageFooter /> :
      <Footer fullWidth={true} className="standard-footer">
        <div className={"portal-footer-top-section-one-brand"}>
            <div className="portal-footer-flexbox portal-footer portal-footer-bottom-border">
              <div className="footer-content">
                <div className="portal-footer-icon">
                  <LogoLibertyMutualVert key="lm-desktop-logo-footer" className="lm-desktop-logo-footer" color="blue"/>   
                  <LogoLibertyMutualMedallion key="lm-tablet-logo-footer" className="lm-tablet-logo-footer" color="blue" />
                </div>
                <div className="portal-content-links lm-blue-footer">
                  {footerContent && footerContent.FlexibleContent && (
                    <RichText className="footer-publisher-section" content={footerContent.FlexibleContent} />
                  )}
                </div>
              </div>
              <div className="portal-footer-social-icon-row">
                <SocialMedia/>
              </div>
            </div>
            <div className="portal-footer-flexbox portal-footer portal-footer-flexbox-link-rows">
              {footerContent && footerContent.Links && 
              <FooterLinks links={footerContent.Links} />}
              <div className="portal-content-links lm-blue-footer">
                <span className="icon-link">
                  <IconCPRA color="blue" size="24" />
                  <a
                    rel="noopener noreferrer"
                    href="https://privacyportal.onetrust.com/hosted-webform/consent/50577d86-8d39-4310-9583-33e6d3da8e17/9b108b70-4ef6-4d93-b7ec-60e41f03b292"
                    target="_blank"
                    title="View your California Privacy Choices"
                  >
                    Your California Privacy Choices
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    rel="noopener noreferrer"
                    onClick={() => CRPAClick()}
                    target="_blank"
                    title="Do Not Sell or Share My Personal Information (CA Residents Only)"
                  >
                    Do Not Sell or Share My Personal Information (CA Residents Only)
                  </a>
                </span>
              </div>
            </div>
        </div>
        <div className={"container portal-footer-bottom-section-one-brand"}>
          <Disclaimer>
            <p>© {new Date().getFullYear()} Liberty Mutual Insurance Company, 175 Berkeley Street, Boston, MA 02116</p>
          </Disclaimer>
        </div>
      </Footer>}
    </>
  );
}
